/**
 * dom.ts — tiny DOM helpers used across modes.
 */

/** Create an element with optional attributes and children. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs?: Record<string, string>,
  ...children: (HTMLElement | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag)
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      node.setAttribute(k, v)
    }
  }
  for (const child of children) {
    if (typeof child === 'string') {
      node.appendChild(document.createTextNode(child))
    } else {
      node.appendChild(child)
    }
  }
  return node
}

/** Find all elements matching a selector, typed. */
export function queryAll<K extends keyof HTMLElementTagNameMap>(
  selector: string,
  root: Document | HTMLElement = document,
): Array<HTMLElementTagNameMap[K]> {
  return Array.from(root.querySelectorAll<HTMLElementTagNameMap[K]>(selector))
}
